import React, { useContext, useEffect, useState } from "react";
import DeviceTypeField from "./DeviceTypeField";
// import ChooseDeviceField from "./ChooseDeviceField";
import ChooseDeviceFieldSearch from "./ChooseDeviceFieldSearch";
// import FetchButton from "./FetchButton";
// import UploadButton from "./UploadButton";
import SelectMsbField from "./SelectMsbField";
import ValidateButton from "./ValidateButton";
import { getValidationStatus } from "../ruleService";
import { ValidationStatus } from "../../vars";
import * as deviceService from "../../devices/deviceService";
import { getFilters } from "../../view/urlService";
import { TableContext } from "../../index";
import * as ruleService from "../ruleService";
// import * as urlService from "../../view/urlService";
// import { useHistory } from "react-router-dom";
// import { sortObjectsByAlphabet } from "../../utils";
import ValidationResultTableSearchSection from "../ValidationResultTableSearchSection";
import ScheduleValidateButton from './ScheduleValidateButton';
import {Loader2 } from "lucide-react";

export function ValidateTableManagement() {

    // const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const [selectedDeviceTypeId, setSelectedDeviceTypeId] = useState();
    const [deviceId, setDeviceId] = useState();
    const [msbId, setMsbId] = useState();
    const [pageData, setPageData] = useState({});
    const [validationStatus, setValidationStatus] = useState('');
    //const [prevValidationTimestamp, setPrevValidationTimestamp] = useState(null);

    const fetchData = async () => {
        try {
            const { deviceList, deviceTypes: deviceTypeList } = await deviceService.loadAssignedDeviceTargetTypes();

            const pageFilters = getFilters(true);

            let deviceType;
            let device;
            let msb;
            let msbList = [];

            if (pageFilters.deviceType) {
                deviceType = deviceTypeList.find(deviceType => deviceType.name === pageFilters.deviceType);
                const selectedDeviceTypeId = deviceType?.id;
                if (selectedDeviceTypeId) {
                    msbList = await ruleService.fetchMsbListByDeviceTypeId(selectedDeviceTypeId);
                }

                if (pageFilters.device) {
                    device = deviceList.find(device => device.hostName === pageFilters.device);
                }

                if (pageFilters.msb) {
                    msb = msbList.find(msb => msb.name === pageFilters.msb);
                }
            }

            deviceType && setSelectedDeviceTypeId(deviceType.id);

            if (!pageFilters.deviceType && deviceTypeList.length) {
                // const deviceTypesCopy = sortObjectsByAlphabet(deviceTypeList, 'name');
                // setSelectedDeviceTypeId(deviceTypesCopy[0].id);

                // history.replace({
                //     pathname: history.pathname,
                //     search: urlService.replaceFilters('deviceType', deviceTypesCopy[0].name)
                // })
            }

            let newTableConfig = config;

            if (device) {
                newTableConfig = { ...newTableConfig, deviceId: device.id };
                setDeviceId(device.id);
            }

            if (msb) {
                newTableConfig = { ...newTableConfig, msbId: msb.id };
                setMsbId(msb.id);
            }

            setConfig({ ...newTableConfig, filtersLoading: false });
            setPageData({ deviceList, deviceTypeList, msbList });
        } catch (error) {
            console.error('Error:', error);
            setConfig({ ...config, filtersLoading: false });
            setPageData({
                deviceList: [],
                deviceTypeList: [],
                msbList: []
            });
        }
    };

    const loadMsbsByDeviceType = async (deviceTypeId) => {
        if (!deviceTypeId || Number(deviceTypeId) === -1) {
            setPageData(prev => ({ ...prev, msbList: [] }));
            return;
        }

        const msbList = await ruleService.fetchMsbListByDeviceTypeId(deviceTypeId);
        setPageData(prev => ({ ...prev, msbList: msbList || [] }));
    };

    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);

    useEffect(() => {
        loadMsbsByDeviceType(selectedDeviceTypeId);
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [selectedDeviceTypeId]);


    useEffect(() => {
        updateValidationStatus();
    }, [msbId, deviceId])

    const updateValidationStatus = async () => {
        if (!deviceId || !msbId) {
            return;
        }
        if (deviceId < 0 || msbId < 0) {
            return;
        }
        if (!isNaN(deviceId) && !isNaN(msbId)) {
            const result = await getValidationStatus(deviceId, msbId);
            //let configUpdated = false;

            if (result.status === ValidationStatus.DONE &&
                validationStatus === ValidationStatus.PROCESSING) {
                //setConfig({ ...config, lastUpdated: Date.now(), filtersLoading: false });
                setConfig({ ...config, filtersLoading: false });
                //configUpdated = true;
            }

            if (validationStatus !== result.status) {
                setValidationStatus(result.status);
            }

            // if (prevValidationTimestamp && !configUpdated) {
            //     const prev = Number(prevValidationTimestamp);
            //     const current = Number(result.lastValidationTimestamp)
            //     if (prev !== current) {
            //         setConfig({ ...config, lastUpdated: Date.now() })
            //     }
            // }
            //setPrevValidationTimestamp(result.lastValidationTimestamp);

        }
    }


    //Configure the ScheduleValidationModel
    // const [setShowModal] = useState(false);
    // const [ setModalProps] = useState({});

    // const handleShowModal = (props) => {
    //     setModalProps(props);
    //     setShowModal(true);
    // }

    // const onCloseModal = () => {
    //     history.go(0);
    //     setShowModal(false);
    // }

    // const handleDeviceTypeChange = (type) => {
    //     setSelectedDeviceType(type);
    // };

    // const handleDeviceChange = (deviceId) => {
    //     setSelectedDeviceId(deviceId);
    // };

    // const handleMsbChange = (msbId) => {
    //     setSelectedMsbId(msbId);
    // };

    return (
        <>
            <div className="oct_filter-section-v2">
                {/* Row 1: Device Type, Choose Device, Select MSB */}
                <div className="row mb-3">
                    <div className="col">
                        <label className="oct_filter-label">Device Type</label>
                        <DeviceTypeField selectType={setSelectedDeviceTypeId}
                            selectedType={selectedDeviceTypeId}
                            deviceTypes={pageData.deviceTypeList}
                            setMsbId={setMsbId}
                            setDeviceId={setDeviceId} />
                    </div>
                    <div className="col">
                        <label className="oct_filter-label">Choose Device</label>
                        <ChooseDeviceFieldSearch selectedType={selectedDeviceTypeId}
                            setDeviceId={setDeviceId}
                            deviceId={deviceId}
                            devices={pageData.deviceList} />
                    </div>
                    <div className="col">
                        <label className="oct_filter-label">Select MSB</label>
                        <SelectMsbField selectedType={selectedDeviceTypeId}
                            msbList={pageData.msbList}
                            setMsbId={setMsbId}
                            msbId={msbId} />
                    </div>
                </div>

                {/* Row 2: Filter/Search */}
                <div className="mb-3">
                    <label className="oct_filter-label">Filter/Search</label>
                    <ValidationResultTableSearchSection />
                </div>

                {/* Row 3: Action Buttons */}
                <div className="d-flex align-items-center justify-content-end mb-2">
                    <div className="mr-2">
                        <ScheduleValidateButton
                            setSelectedDeviceTypeId={setSelectedDeviceTypeId}
                            selectedDeviceTypeId={selectedDeviceTypeId}
                            pageData={pageData}
                            setMsbId={setMsbId}
                            setDeviceId={setDeviceId}
                            deviceId={deviceId}
                            msbId={msbId}
                        />
                    </div>

                    <ValidateButton deviceId={deviceId}
                        msbId={msbId}
                        validationStatus={validationStatus}
                        setValidationStatus={setValidationStatus} />
                </div>

                {/* Row 4: Validation Status Label */}
                {validationStatus === ValidationStatus.PROCESSING && (
                    <div className="oct_validation-progress-banner-v2">
                        <div className="d-flex align-items-center">
                            <div className="oct_validation-loader-circle-v2">
                                <Loader2 className="validate_animate-spin oct_validation-loader-icon-v2" />
                            </div>
                            <div className="flex-fill">
                                <h3 className="oct_validation-title-v2">
                                    Validation in Progress
                                </h3>
                                <div className="text-muted text-sm">Please wait while the validation process completes...</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
